import { useQuery } from "react-query";
import { client } from "shared/helpers/client";

export const GetOwnerStatistics = () => client('/Owner/GetOwnerStatisticsByOwnerId')

export function useOwnerStatistics() {
    const result = useQuery('owner-static', async () => {
        const { response } = await GetOwnerStatistics()
        if (response) return response
    })

    return { ...result, ownerStatic: result.data ?? [] }
}

